/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PointsTransactionsHistoryListPostRequest } from '../models/PointsTransactionsHistoryListPostRequest';
import type { TransactionsHistoryResponse } from '../models/TransactionsHistoryResponse';
import { request as __request } from '../core/request';

export class PointsService {

    /**
     * @returns string Ok
     * @throws ApiError
     */
    public static async getPoints(): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/points/checkPoints`,
            errors: {
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns TransactionsHistoryResponse Ok
     * @throws ApiError
     */
    public static async getPointsTransactionHistory(
        requestBody: PointsTransactionsHistoryListPostRequest,
    ): Promise<TransactionsHistoryResponse> {
        const result = await __request({
            method: 'POST',
            path: `/points/transactionsHistory/list`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}